export const availableOfficeEditorFonts = [
  'Arial',
  'Arial Black',
  'Arial Narrow',
  'Arial Rounded MT Bold',
  'Baskerville Old Face',
  'Bookman Old Style',
  'Bookshelf Symbol 7',
  'Brush Script MT',
  'Calibri',
  'Calibri Light',
  'Cambria',
  'Cambria Math',
  'Century',
  'Century Schoolbook',
  'Comic Sans MS',
  'Consolas',
  'Cooper Black',
  'Copperplate Gothic Light',
  'Courier',
  'Courier New',
  'Garamond',
  'Georgia',
  'Gill Sans MT',
  'Gill Sans MT Condensed',
  'Helvetica',
  'Lucida Console',
  'MS Outlook',
  'Malgun Gothic',
  'Meiryo',
  'monospace',
  'Myriad Pro',
  'sans-serif',
  'serif',
  'SimSun',
  'Symbol',
  'Tahoma',
  'Tahoma Bold',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana',
];
